<template>
  <div>
    <iframe
        width="100%"
        height="150"
        class="fl-sym-rounded fl-custom-map"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        id="gmap_canvas"
        :src=mapSrc
    ></iframe>
  </div>
</template>

<script>


export default {
  data() {
    return {
      coordinates: {
        lat: 51.5,
        lng: -0.124,
      },
      mapZoomLevel: 12,
      mapSearchTerm: "veterinarians+near+me",
      mapApiKey: process.env.VUE_APP_GOOGLE_MAP_API
    }
  },
  computed: {
    mapSrc() {
      return `https://www.google.com/maps/embed/v1/search?key=${this.mapApiKey}
      &zoom=${this.mapZoomLevel}
      &center=${this.coordinates.lat},${this.coordinates.lng}
      &q=${this.mapSearchTerm}`

    }
  },
  created() {
    // get users coordinates from browser req
    this.$getLocation({})
        .then(coordinates => {
          this.coordinates = coordinates;
        })
        .catch(error => console.warn(error))
  },

}
</script>